import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {QUESTION} from "../../../Config/ApiUrl";
import {formatDateTimeToLocalDate} from "../../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            options: {
                name: this.$t('questions.title'),
                url: QUESTION + `?lesson_id=${this.props.lesson_id}`,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                tableShadow: false,
                columns: [
                    {
                        title: this.$t('lesson'),
                        type: 'custom-html',
                        key: 'lesson',
                        isVisible: true,
                        modifier: (lesson) => {
                            return lesson ? lesson.title ? lesson.title : '-' : '-';
                        }
                    },
                    {
                        title: this.$t('questions.question_text'),
                        type: 'text',
                        key: 'question_text',
                        isVisible: true,
                    },
                    {
                        title: this.$t('questions.question_type'),
                        type: 'text',
                        key: 'question_type',
                        isVisible: true,
                    },
                    {
                        title: this.$t('created'),
                        type: 'custom-html',
                        key: 'created_at',
                        isVisible: true,
                        modifier: (value) => {
                            return formatDateTimeToLocalDate(value);
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('edit'),
                        type: 'modal',
                        component: 'app-question-modal',
                        modalId: 'question-modal',
                        url: QUESTION,
                        name: 'edit',
                        modifier: row => this.$can('update_question')
                    },
                    {
                        title: this.$t('delete'),
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'question-modal',
                        url: QUESTION,
                        name: 'delete',
                        modifier: row => this.$can('delete_question')
                    },
                    {
                        title: this.$t('view_details'),
                        key: "view_details",
                        name: 'view_details',
                        url: QUESTION,
                    },
                ],
            }
        }
    }
}
export function isImage(url) {
    return /\.(jpeg|jpg|gif|png|svg|webp)$/i.test(url);
}
